import { z } from "zod";

export const workerApprovalStatusSchema = z.enum([
  "pending",
  "approved",
  "rejected",
  "removed",
]);

export const workerApprovalCreated = z.object({
  type: z.literal("WorkerApprovalCreated"),
  approvalId: z.string().min(1),
  workerId: z.string().min(1),
  siteId: z.string().min(1),
  status: workerApprovalStatusSchema,
  addedBy: z.string().nullable().optional(),
});

export const workerApprovalStatusChanged = z.object({
  type: z.literal("WorkerApprovalStatusChanged"),
  approvalId: z.string().min(1),
  status: workerApprovalStatusSchema,
  removedBy: z.string().nullable().optional(),
  removedAt: z.date().nullable().optional(),
  reason: z.string().nullable().optional(),
});

export const workerApprovalEvents = [
  workerApprovalCreated,
  workerApprovalStatusChanged,
] as const;
